import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { clsx as u } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as L } from "react";
import { remCalc as j } from "../../style/base/index.js";
import { formatRequiredLabel as T } from "../../utils/label-formatter.js";
import { RocheUIIcon as I } from "../icon/roche-icon.js";
import { RocheUITooltip as W } from "../tooltip/roche-tooltip.js";
import e from "./roche-dropdown.module.scss.js";
import { RocheUIDropdownAppearance as D } from "./roche-dropdown.types.js";
const Y = 16, Z = 24, Q = ({
  id: d,
  name: b,
  label: n,
  ariaLabel: R,
  tooltip: i,
  tooltipAriaLabel: C,
  options: O,
  value: t,
  placeholder: h,
  error: a,
  hasError: m = !1,
  required: p = !1,
  disabled: _ = !1,
  hasMarginTop: x = !0,
  appearance: S = D.DEFAULT,
  slot: y,
  onChange: w,
  onBlur: s
}) => {
  const f = S === D.SECONDARY, v = `${d}-error`, P = (r) => {
    w && w(r.target.value);
  }, [U, l] = L(!1), g = () => {
    l(!1), s == null || s();
  }, A = u(
    e["roche-dropdown"],
    _ && [e["roche-dropdown--disabled"]],
    (a || m) && [e["roche-dropdown--error"]],
    !x && [e["roche-dropdown--no-margin"]],
    f && [e["roche-dropdown--secondary"]]
  ), E = u(
    e["roche-dropdown__select"],
    !t && h && [e["roche-dropdown__select--placeholder"]],
    U && [e["roche-dropdown__select--pointer-focused"]]
  ), N = !!(a || m);
  return /* @__PURE__ */ c("div", { className: A, slot: y, children: [
    n && /* @__PURE__ */ c("div", { className: e["roche-dropdown__label-wrapper"], children: [
      /* @__PURE__ */ o("label", { htmlFor: d, className: e["roche-dropdown__label"], children: T(p, n) }),
      i && /* @__PURE__ */ o(W, { ariaLabel: C, children: i })
    ] }),
    /* @__PURE__ */ c("div", { className: e["roche-dropdown__container"], children: [
      /* @__PURE__ */ c(
        "select",
        {
          id: d,
          name: b,
          value: t || "",
          required: p,
          disabled: _,
          onChange: P,
          onPointerDown: () => l(!0),
          onKeyDown: () => l(!1),
          onBlur: g,
          className: E,
          "aria-label": n ? void 0 : R,
          "aria-invalid": N,
          "aria-describedby": N ? v : void 0,
          children: [
            /* @__PURE__ */ o("option", { value: "", disabled: !0, children: h }),
            O.map((r, F) => /* @__PURE__ */ o("option", { value: r.value || r.label, children: r.label }, r.value || r.label || F))
          ]
        }
      ),
      /* @__PURE__ */ o("div", { className: e["roche-dropdown__icon"], children: /* @__PURE__ */ o(
        I,
        {
          icon: "chevron-down",
          height: `${j(f ? Z : Y)}rem`,
          decorative: !0
        }
      ) })
    ] }),
    a && /* @__PURE__ */ c("div", { className: e["roche-dropdown__error"], children: [
      /* @__PURE__ */ o(I, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ o("p", { id: v, role: "alert", className: e["roche-dropdown__error-text"], children: a })
    ] })
  ] });
};
export {
  Q as RocheUIDropdown
};
